import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import $http from '@/api'
import store from '@/store'

export interface UserInfo {
  userInfo: Object
  hasLogin: boolean
  init: boolean
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements UserInfo {
  public userInfo = {
    phone: '',
    lastPasswordTime: '',
    isInitPassword: false
  }
  public hasLogin = false
  public init = false

  @Mutation
  private setUserInfo(data: any) {
    this.init = true
    this.hasLogin = data.hasLogin
    this.userInfo = data.userInfo
  }

  @Action
  public async getUserInfo() {
    const { errNo, data } = await $http.checkLogin()
    if (errNo === 0 && data && data.uid && data.uid > 0) {
      const params = {
        hasLogin: true,
        userInfo: {
          phone: data.phone,
          lastPasswordTime: data.lastPasswordTime,
          isInitPassword: data.isInitPassword
        }
      }
      this.setUserInfo(params)
    } else {
      const params = {
        hasLogin: false,
        userInfo: {
          phone: '',
          lastPasswordTime: '',
          isInitPassword: false
        }
      }
      this.setUserInfo(params)
    }
  }
}

export const UserModule = getModule(User)
